const { _ } = require("core-js");
const d3 = require("d3");
const { getAllFeatures, getFeaturePriority} = require("@/simulation/automation/Features.js");

// const metrics = require("../simulation/metrics/clientSideMetrics");

class ButtonHandler {
  constructor(component) {
    this.component = component;
    this.store = component.$store;
    this.state = component.$store.state;
    //Dictionary for mapping a message to the associated function
    this.functionMapper = {
      pressedHome: this.pressedHome,
      pressedPlay: this.pressedPlay,
      pressedStep: this.pressedStep,
      pressedPause: this.pressedPause,
      pressedSort: this.pressedSort,
      pressedDebug: this.pressedDebug,
      pressedRefresh: this.pressedRefresh,
      pressedReset: this.pressedReset,
      pressedNewSimulation: this.pressedNewSimulation,
      pressedSavePortfolioSettings: this.pressedSavePortfolioSettings,
      pressedLoadPortfolioSettings: this.pressedLoadPortfolioSettings,
      pressedSimulate: this.pressedSimulate,
      pressedRequest: this.pressedRequest,
    };
  }

  pressedRefresh(){
    if(this.state.futureLoadGraph != null){
      this.state.futureLoadGraph.reset(false);
      this.state.visualiser.updateFutureLoadGraphCamera(0);
    }
  }

  //Call the associated function
  pressedButton(buttonID) {
    var func = this.functionMapper[buttonID];
    func.bind(this)();
  }


  //A single step
  pressedStep() {
    this.state.pipelineHandler.pressedPlay(true);
    this.pressedPause();
  }

  //Handles the networking request
  pressedRequest() {
    this.state.networkHandler.pressedRequest();
  }

  //Handles the networking responses
  handleResponse(response) {
  }

  //Go back to the home screen
  pressedHome() {
    this.state.visualiser.resetViewPort();
  }

  //Remove all the finished projects
  pressedSort() {
    this.state.visualiser.sortProjects();
  }

  pressedPlay() {
    if (this.state.manuallyPaused) {
      this.state.manuallyPaused = false;
      this.state.pipelineHandler.pressedPlay(false);
    }
    else {
      this.pressedPause();
    }
  }

  pressedPause() {
    this.state.manuallyPaused = true;
    this.state.visualiser.updateElements(true);

    if(this.state.simulator.params.allowPortfolioPlanning && this.state.futureLoadGraph != null){
      this.state.futureLoadGraph.updateData();
    }
  }

  pressedSavePortfolioSettings(){
    
  }



  pressedDebug() {
    console.log(this.state.simulator.finishedTasks);
  }

  pressedReset() {
    this.component.$swal
      .fire({
        title: "Are you sure you want to reset the simulation?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Reset!",
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.state.pipelineHandler.resetEnvironment();

          var simulator = this.store.getters.getSimulationFromName(this.state.simulator.params.simulationName);
          this.state.pipelineHandler.init(simulator);
          this.pressedHome();
        }
      });
  }

  pressedNewSimulation() {
    var simulationOptions = {};
    this.state.Simulations.forEach((currSimulation) => {
      var name = currSimulation["Simulation_Name"];
      simulationOptions[name] = name;
    });

    var self = this;
    this.component.$swal({
      title: "New Simulation",
      text: "Select a simulation method",
      input: "select",
      inputOptions: simulationOptions,
      showCancelButton: true,
      animation: "slide-from-top",
    }).then(function (inputValue) {
      if (inputValue && inputValue.isConfirmed) {
        var selectedSimulationName = inputValue.value;

        self.state.pipelineHandler.resetEnvironment();
        var selectedSim = self.store.getters.getSimulationFromName(selectedSimulationName);
        self.state.pipelineHandler.init(selectedSim);
        self.pressedHome();
      }
    });
  }

  pressedSimulate() {
    this.state.manuallyPaused = false;
    this.state.pipelineHandler.startAutomaticPlay(true, false);
  }

  
}


module.exports = { ButtonHandler };
